export default __webpack_public_path__ + "static/media/PersonHold1.8e45314a.svg";